export default __webpack_public_path__ + "static/media/bg_head_new.ae93a5de.jpg";